import { createFileRoute } from "@tanstack/react-router";

import NewScheduleForm from "../../-components/Purchase/Recurring/NewScheduleForm";

export const Route = createFileRoute("/_authenticated/trade/purchase/recurring/new")({
  component: NewScheduleForm,
  context: () => ({ permissions: "trade.purchase.recurring" }),
});
